import styles from './IndividualExtensionContent.module.css';
import logo from '../../assets/les-logo.png';
import ProfileCard from '../ProfileCard/ProfileCard';
import CustomSlider from '../CustomSlider/CustomSlider';


export default function IndividualExtensionContent() {

    const partners = Array.from({ length: 2 }, (v, k) =>
        <ProfileCard
            key={k}
            imageUrl={logo}
            name='Lorem ipsum'
            seeMore={'Saiba Mais'}
            withButton={false}
            withIconGit={false}
        />);

    return (
        <main className={styles.main}>
            <section className={styles.extension_description}>

                <div className={styles.extension_name}>
                    <h2>TÍTULO DA EXTENSÃO</h2>
                </div>

                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nullam auctor, nisl id aliquet ultricies, nunc libero
                    fermentum urna, et varius nunc ipsum nec sapien.
                    Donec eget purus nec nunc tincidunt ultricies.
                    Donec auctor, justo nec rhoncus tincidunt,
                    dui mi aliquet libero, a luctus purus libero ac nunc.
                    Nullam auctor, nisl id aliquet ultricies, nunc libero
                    fermentum urna, et varius nunc ipsum nec sapien.
                    Donec eget purus nec nunc tincidunt ultricies.
                    Donec auctor, justo nec rhoncus tincidunt,
                    dui mi aliquet libero, a luctus purus libero ac nunc.
                    Nullam auctor, nisl id aliquet ultricies, nunc libero
                    fermentum urna, et varius nunc ipsum nec sapien.
                    Donec eget purus nec nunc tincidunt ultricies.
                    Donec auctor, justo nec rhoncus tincidunt,
                    dui mi aliquet libero, a luctus purus libero ac nunc.
                    Nullam auctor, nisl id aliquet ultricies, nunc libero
                    fermentum urna, et varius nunc ipsum nec sapien.
                    Donec eget purus nec nunc tincidunt ultricies.
                    Donec auctor, justo nec rhoncus tincidunt,
                    dui mi aliquet libero, a luctus purus libero ac nunc.
                </p>

                <div className={styles.artifacts_container}>

                    <h2> Artefatos </h2>

                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nullam auctor, nisl id aliquet ultricies, nunc libero
                        fermentum urna, et varius nunc ipsum nec sapien.
                        Donec eget purus nec nunc tincidunt ultricies.
                        Donec auctor, justo nec rhoncus tincidunt,
                        dui mi aliquet libero, a luctus purus libero ac nunc.
                        Nullam auctor, nisl id aliquet ultricies, nunc libero
                        fermentum urna, et varius nunc ipsum nec sapien.
                        Donec eget purus nec nunc tincidunt ultricies.
                    </p>
                </div>

            </section>

            <section className={styles.patner_companies}>
                <h2>EMPRESAS PARCEIRAS</h2>

                <div className={styles.partners}>
                    <CustomSlider elements={partners} />
                </div>
            </section>
        </main>

    );
}

